import { render, staticRenderFns } from "./LocalizedQuestions.vue?vue&type=template&id=8af3ae3c&"
import script from "./LocalizedQuestions.vue?vue&type=script&lang=js&"
export * from "./LocalizedQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports